module.exports = __webpack_public_path__ + "img/chipin-plus-badge.cb27525f.svg";